// Section : Features
// Style : Four Columns Features Section

// import node module libraries
import { Col, Row, Container } from 'react-bootstrap';

// import custom components
import SectionHeadingCenter from 'components/marketing/common/section-headings/SectionHeadingCenter';
import FeatureTopIcon from 'components/marketing/common/features/FeatureTopIcon3';
import { useTranslation } from 'react-i18next';

const Features4Columns = () => {
	const { t } = useTranslation(); // useTranslation-Hook

	const title = t('Why e-commerce merchants should rely on automation');
	const subtitle = t('More than just an automation platform');
	const description = t('We offer you a platform that helps you automate and optimize your e-commerce processes.');

	const features = [
		{
			id: 1,
			icon: 'settings',
			title: t('Higher productivity through automation'),
			description: t('With our flows, you automate recurring manual tasks and thus increase the productivity of your e-commerce business.')
		},
		{
			id: 2,
			icon: 'trending-up',
			title: t('Dashboard and analytics tool'),
			description: t('In addition to automation, we offer you a dashboard to keep track of your flows. Additionally, flow-specific graphical analyses can be realized.')
		},
		{
			id: 3,
			icon: 'users',
			title: t('Customer-specific possibilities'),
			description: t('On request, we also implement customer-specific requirements, e.g., with new connectors or general further')
		},
		{
			id: 4,
			icon: 'award',
			title: t('Server location in the EU'),
			description: `Wir betreiben alle unsere Server in zertifizierten Deutschen oder EU-Rechenzentren und alle Datenübertragungen werden verschlüsselt.​`
		}
	];

	return (
		<section className="py-8 py-lg-18 bg-white">
			<Container>
				<SectionHeadingCenter
					title={title}
					description={description}
					subtitle={subtitle}
				/>
				<Row className="text-center text-md-start">
					{features.map((item, index) => {
						return (
							<Col lg={3} md={6} sm={12} key={index}>
								<FeatureTopIcon item={item} />
							</Col>
						);
					})}
				</Row>
			</Container>
		</section>
	);
};

export default Features4Columns;
